module.exports = __webpack_public_path__ + "img/grid.b2171f61.png";